import {IDiagnosisIdNode} from '../_interface/diagnosisid-node.interface';
import {IDiagnosis} from '../_interface/diagnosis.model';
import {isEmpty} from 'lodash-es';

export const removeNode = (obj: IDiagnosisIdNode, nodeId: string, parent: IDiagnosis) => {
	for (const node in obj) {
		if (node === nodeId) {
			delete obj[nodeId];
		} else if (typeof obj[node] === 'object') {
			removeNode(obj[node], nodeId, parent);
			if (node === parent?.diagnosisId && isEmpty(obj[node])) {
				obj[node] = null;
			}
		}
	}
};
